
import {Style} from '@/libs/style.js';

// import Core from '@/libs/src/core.js'
// console.log(Core)
// let mqtt  = Core.getProvider('MQTT');

let style = /* css */`
    .loading-container{
        z-index:999;
        position:absolute;
        color: #fff;
        top: 0;
    }
`;
export default (Vue)=>{
    Vue.customElement('loding-1', {
        data(){
            return {
                show: true,
            }
        },
        template: /* html */ `
        <dv-loading v-if="show" class="loading-container">连接设备中...</dv-loading>`,
        mounted() {
            Style(style);
            let mqtt = this.$Core.getProvider('MQTT');
            mqtt.on('subscribe.success',()=>{
                this.show = false;
            })
            // 超时
            setTimeout(()=>{
                this.show = false;
            },5000)
        }
    });
} 